"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = merge;

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function merge() {
  for (var _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++) {
    objects[_key] = arguments[_key];
  }

  return objects.reduce(function (accum, object) {
    if (_typeof(object) !== 'object') {
      throw new Error('merge only works on objects');
    }

    for (var key in object) {
      if (_typeof(object[key]) === 'object' && _typeof(accum[key]) === 'object' && !Array.isArray(object[key])) {
        accum[key] = merge(accum[key], object[key]);
      } else if (Array.isArray(accum[key]) || Array.isArray(object[key])) {
        var result = (accum[key] ? accum[key] : []).concat(object[key] ? object[key] : []);
        accum[key] = result;
      } else {
        accum[key] = object[key];
      }
    }

    return accum;
  }, {});
}